import {React,useState,useMemo} from 'react';
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Controller } from "react-hook-form";
import { Box, IconButton } from "@mui/material";
import { InputAdornment, Icon } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import Tooltip from "@mui/material/Tooltip";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import ImageUrlPopup from 'layouts/components/ImageUrlPopup';
import noImage from "assets/images/no-image.png";
import { PRODUCT } from 'constants.js';
import { handleSkuExist } from "common.js";

const EditRow = (props) => {
  const { urlPopup, selectedRow, t, productId, setUrlPopup, handleErrors, navigate, mediaList, setMediaList, setSelectedRow, variantMediaLoading, responseData, tracks,
    selectedDialogCountryOfOrgin, selectedDialogHsnCode, countries, MyContext, handleProductMediaDelete, DropzoneAreaBase, fileTypes, handleMediaUrlOpen,
    handleProductMediaUpload, setSelectedDialogCountryOfOrgin, setSelectedDialogHsnCode, setVariantErrors, errors, register, watch, control, setValue, getValues, setError, clearErrors,
    trigger, variantsList, setVariantsList, setEditOpen, dialogDigitalProductInfo, setDialogDigitalProductInfo, digitalType, digitalFileUploadLoading, dialogDigitalFileInfo,
    setDialogDigitalFileInfo, units, handleDigitalFileUpload, isURL, toast, setIsLoading } = props;

/* modification for volumetric display */

const [volumetricWidth, setVolumetricWidth] = useState(selectedRow.width);
const [volumetricHeight, setVolumetricHeight] = useState(selectedRow.height);
const [volumetricLength, setVolumetricLength] = useState(selectedRow.length);

const volumetricWeight = useMemo(() => {
  if (volumetricWidth > 0 && volumetricHeight > 0 && volumetricLength > 0) {
    return (
      (volumetricLength * volumetricHeight * volumetricWidth) / 5000 );
  }
  return null;
}, [volumetricWidth, volumetricHeight, volumetricLength]);

  const handleEditVariantClose = () => {
    setEditOpen(false);
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault()
    const isValidPrice = await trigger('dialogPrice');
    const isValidComparePrice = await trigger('dialogComparePrice');
    const isValidSku = await trigger('dialogSku');
    const isValidWeight = await trigger('dialogWeight');
    const isValidWidth = await trigger('dialogWidth');
    const isValidHeight = await trigger('dialogHeight');
    const isValidLength = await trigger('dialogLength');
    const isValidQuantity = await trigger('dialogQuantity');
    const isValidNumberOfAccessibleDays = await trigger('dialogNumberOfAccessibleDays');
    const isValidNumberOfDownloads = await trigger('dialogNumberOfDownloads');
    const isValidDialogDigitalProductFileLink = await trigger('dialogDigitalProductFileLink');
    const isValidDialogDigitalFile = await trigger('dialogDigitalFile');

    if (isValidPrice && isValidWeight && isValidQuantity && isValidComparePrice && isValidNumberOfAccessibleDays && isValidNumberOfDownloads && isValidDialogDigitalProductFileLink && isValidWidth && isValidHeight && isValidLength && isValidSku && isValidDialogDigitalFile) {
      setVariantErrors(t(''))
      let variantDigitalProductInfo = {};
      if (getValues('dialogDigitalType') == 'file') {
        variantDigitalProductInfo = { type: getValues('dialogDigitalType'), noOfAccessDays: getValues('dialogNumberOfAccessibleDays'), noOfDownloads: getValues('dialogNumberOfDownloads'), fileInfo: dialogDigitalFileInfo }
      }
      else {
        variantDigitalProductInfo = { type: getValues('dialogDigitalType'), noOfAccessDays: getValues('dialogNumberOfAccessibleDays'), noOfDownloads: getValues('dialogNumberOfDownloads'), fileUrl: getValues('dialogDigitalProductFileLink') }
      }
      const updatedList = variantsList.map((row) => {
        if (row.id === selectedRow.id) {
          return {
            ...row,
            price: parseFloat(getValues('dialogPrice')),
            compareAtPrice: getValues('dialogComparePrice') ? parseFloat(getValues('dialogComparePrice')) : 0,
            taxable: getValues('dialogTaxable'),
            sku: getValues('dialogSku'),
            barcode: getValues('dialogBarcode'),
            minPurchaseQuantity: getValues('dialogMinPurchaseQuantity'),
            trackInventory: getValues('dialogTrackInventory'),
            quantity: getValues('dialogTrackInventory') ? getValues('dialogQuantity') : '',
            inventoryPolicy: getValues('dialogInventoryPolicy'),
            shippingRequired: getValues('dialogRequireShipping'),
            weight: getValues('dialogWeight') ? parseFloat(getValues('dialogWeight')) : '',
            weightUnit: getValues('dialogWeightUnit'),
            width: parseFloat(getValues('dialogWidth')),
            height: parseFloat(getValues('dialogHeight')),
            length: parseFloat(getValues('dialogLength')),
            countryOfOrgin: getValues('dialogCountryOfOrgin'),
            hsnCode: getValues('dialogHsnCode'),
            digitalProductInfo: variantDigitalProductInfo,
          };
        }
        return row;
      });
      setVolumetricWidth(getValues('dialogWidth'));
      setVolumetricHeight(getValues('dialogHeight'));
      setVolumetricLength(getValues('dialogLength'));

      setVariantsList(updatedList)
      setEditOpen(false);
    }
    else {
      setVariantErrors(t('variantErrors'))
    }
  }

  return (
    <Card className="EditContentSec">
      <Grid item xs={12} md={12} lg={12}>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters"  >{t('variantEdit')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography variant="body1" className="labelStyle">{t('title')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <MDInput
                type="text"
                className="backgoundNone"
                name="dialogName"
                InputProps={{
                  classes: { root: "inputBoxStyle" },
                }}
                value={selectedRow.title}
                onChange={((e) => { e.stopPropagation() })}
                disabled
                fullWidth />
              {errors.dialogName && (
                <span className="errorMsg FloatRight">{errors.dialogName.message}</span>
              )}
            </Grid>
            {/*  variant image start*/}
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography variant="h6" className="uppercaseLetters"  >{t('variantImage')}</MDTypography>
              <MDTypography component="span" variant="body2" >{t('editVariantImageHere')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              {selectedRow.image == "" ?
                <>
                  <Grid item xs={12} sm={6} md={4} lg={3} className="dropzoneAreaBaseGrid">
                    {variantMediaLoading ? (
                      <MDBox className="VarientcircularProgressStyle">
                        <CircularProgress color='success' size={40} className="mediaLoadingProgress" />
                      </MDBox>
                    ) : null
                    }
                    <Tooltip title={t('addFiletypes')} arrow  >
                      <Card className="dropzoneupload " >
                        <DropzoneAreaBase
                          acceptedFiles={fileTypes}
                          filesLimit={9999}
                          dropzoneText={t('add')}
                          onAdd={(files) => handleProductMediaUpload(files, "variant", selectedRow.variantId ? selectedRow.variantId : '')}
                          dropzoneClass={"dropzonestyle"}
                          Icon={''}
                          maxFileSize={20 * 1024 * 1024}
                        />
                        <MDButton variant="outlined" color="info" disableRipple className="addUrlButton" onClick={handleMediaUrlOpen} >{t('addFromUrl')}</MDButton>
                      </Card>
                    </Tooltip>
                    {urlPopup ?
                      <ImageUrlPopup
                        imageFrom="variant"
                        urlPopup={urlPopup}
                        handleMediaUrlClose={() => setUrlPopup(false)}
                        selectedRow={selectedRow}
                        t={t}
                        productId={productId}
                        setUrlPopup={setUrlPopup}
                        handleErrors={handleErrors}
                        navigate={navigate}
                        mediaList={mediaList}
                        setMediaList={setMediaList}
                        setSelectedRow={setSelectedRow}
                        register={register}
                        watch={watch}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                        setError={setError}
                        trigger={trigger}
                        errors={errors}
                        toast={toast}
                        setIsLoading={setIsLoading}
                      /> :
                      null
                    }
                  </Grid>
                </>
                :
                <>
                  <Grid item xs={12} sm={6} md={4} lg={3} className="dropzoneAreaBaseGrid FloatLeft">
                    {variantMediaLoading ? (
                      <MDBox className="VarientcircularProgressStyle">
                        <CircularProgress color='success' size={40} className="mediaLoadingProgress" />
                      </MDBox>
                    ) : null
                    }
                    <MDBox component="img" src={selectedRow.image || noImage} className="customFieldImage marginRight10 " />
                  </Grid>
                  <IconButton
                    size="small"
                    disableRipple
                    variant="contained"
                    className="VarientFieldImage"
                    onClick={(e) => { handleProductMediaDelete(e, -1, "variant", selectedRow.variantId ? selectedRow.variantId : "") }}
                  >
                    <Icon className="closeIcon">close</Icon>
                  </IconButton>
                </>
              }
            </Grid>
            {/* variant image end */}
            {/* variant pricing */}
            <Grid item xs={12}>
              <MDTypography variant="h6" className="uppercaseLetters"  >{t('pricing')}</MDTypography>
              <MDTypography component="span" variant="body2" >{t('addPricingDetails')}</MDTypography>
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <MDTypography variant="body1" className="labelStyle">{t('price')}
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
              </MDTypography>
              <Grid item xs={12} sm={12} md={12}>
                <MDInput
                  type="text"
                  name="dialogPrice"
                  InputProps={{
                    classes: { root: "inputBoxStyle" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <span className="RupeesIcon">₹</span>
                      </InputAdornment>
                    ),
                  }}
                  {...register("dialogPrice", {
                    required: {
                      value: true,
                      message: t('priceRequired')
                    },
                    validate: (value) => {
                      if (Number(value) === 0) {
                        return t('invalidInput');
                      }
                      return true;
                    },
                  })}
                  onChange={((e) => {
                    e.stopPropagation();
                    const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                    setValue("dialogPrice", inputValue);
                  })}
                  fullWidth />
                {errors.dialogPrice && (
                  <span className="errorMsg FloatRight">{errors.dialogPrice.message}</span>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <MDTypography variant="body1" className="labelStyle">{t('comparePrice')}</MDTypography>
              <Grid item xs={12} sm={12} md={12}>
                <MDInput
                  type="text"
                  name="dialogComparePrice"
                  InputProps={{
                    classes: { root: "inputBoxStyle" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <span className="RupeesIcon">₹</span>
                      </InputAdornment>
                    ),
                  }}
                  {...register('dialogComparePrice', {
                    validate: (value) => {
                      if (value && Number(value) === 0) {
                        return t('invalidInput');
                      }
                      return true;
                    },
                  })}
                  placeholder={t('enterCompareAtPrice')}
                  onChange={((e) => {
                    e.stopPropagation();
                    const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                    setValue("dialogComparePrice", inputValue);
                  })}
                  fullWidth
                />
                {errors.dialogComparePrice && (
                  <span className="errorMsg FloatRight">{errors.dialogComparePrice.message}</span>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} lg={6} >
              <MDInput
                type="checkbox"
                name="dialogTaxable"
                variant="standard"
                InputProps={{
                  classes: { root: "inputBoxStyle" },
                }}
                {...register("dialogTaxable", {})}
                className="checkboxStyle"
              />
              <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel">{t('taxable')}</MDTypography>
            </Grid>
            {/* variant invertory start */}
            <Grid item xs={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('inventory')}</MDTypography>
              <MDTypography component="span" variant="body2">{t('addInventoryDetails')}</MDTypography>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <MDTypography variant="body1" className="labelStyle">{t('sku')}</MDTypography>
                  <MDInput
                    type="text"
                    name="dialogSku"
                    placeholder={t('enterSku')}
                    InputProps={{
                      classes: { root: "inputBoxStyle" },
                    }}
                    {...register('dialogSku', {
                      validate: (value) => {
                        if (value && value.length > 16) {
                          return t('skuMax16Chars');
                        }
                        if (value && value.length < 4) {
                          return t('skuMin4Chars');
                        }
                        return true;
                      },
                    })}
                    onChange={e => {
                      e.stopPropagation();
                      const trimmedValue = e.target.value.replace(/ /g, '').trim(); // Remove space characters
                      setValue("dialogSku", trimmedValue);
                    }}
                    onBlur={e => {
                      e.stopPropagation();
                      handleSkuExist(e.target.value, selectedRow.variantId ? selectedRow.variantId : 0, setIsLoading, t, navigate, variantsList)
                    }}
                    fullWidth
                  />
                  {errors.dialogSku && <span className="errorMsg FloatRight">{errors.dialogSku.message}</span>}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <MDTypography variant="body1" className="labelStyle">{t('barcode')}</MDTypography>
                  <MDInput
                    type="text"
                    name="dialogBarcode"
                    placeholder={t('enterBarcode')}
                    InputProps={{
                      classes: { root: "inputBoxStyle" },
                    }}
                    {...register('dialogBarcode', {})}
                    fullWidth
                  />
                  {errors.dialogBarcode && (
                    <span className="errorMsg FloatRight">{errors.dialogBarcode.message}</span>
                  )}
                </Grid>
              </Grid>
            </Grid>
            {watch('type') == PRODUCT.NORMAL ?
              <Grid item xs={12} md={6} lg={6}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <MDTypography variant="body1" className="labelStyle">{t('purchaseQuantity')}</MDTypography>
                    <MDInput
                      type="number"
                      name="dialogMinPurchaseQuantity"
                      placeholder={t('minPurchareQuantity')}
                      InputProps={{
                        classes: { root: "inputBoxStyle" },
                        inputProps: { min: 1 },
                      }}
                      {...register('dialogMinPurchaseQuantity', {})}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              : null}
            <Grid item xs={12} md={6} lg={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <MDTypography variant="body1" className="labelStyle">{t('trackInventory')}</MDTypography>
                  <MDInput
                    select
                    name="dialogTrackInventory"
                    InputProps={{
                      classes: { root: "select-input-styles " },
                    }}
                    value={watch("dialogTrackInventory") || 0}
                    onChange={(event) => setValue('dialogTrackInventory', event.target.value)}
                    fullWidth
                  >
                    {tracks.map((track) => (
                      <MenuItem key={track.value} value={track.value}>{track.name}</MenuItem>
                    ))}
                  </MDInput>
                </Grid>
              </Grid>
            </Grid>
            {watch("dialogTrackInventory") ?
              <>  <Grid item xs={12} md={6} lg={6}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <MDTypography variant="body1" className="labelStyle">{t('quantity')}
                      <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                    </MDTypography>
                    <MDInput
                      type="text"
                      name="dialogQuantity"
                      placeholder={t('enterProductQunatity')}
                      InputProps={{
                        classes: { root: "inputBoxStyle" },
                        min: 1
                      }}
                      {...register('dialogQuantity', {
                        required: {
                          value: true,
                          message: t('quantityRequired'),
                        },
                        pattern: {
                          value: /^[0-9]+$/,
                          message: t('invalidInput'),
                        },
                        validate: (value) => {
                          const minPurchaseQuantity = parseInt(getValues('dialogMinPurchaseQuantity'));
                          if (value >0 && value < minPurchaseQuantity) {
                            return t('quantityShouldGreaterThanMinPurchaseQuantity');
                        }
                          return true;
                        },
                      })}
                      fullWidth
                    />
                    {errors.dialogQuantity && (
                      <span className="errorMsg FloatRight">{errors.dialogQuantity.message}</span>
                    )}
                  </Grid>
                </Grid>
              </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} >
                      <MDInput
                        type="checkbox"
                        name="dialogInventoryPolicy"
                        variant="standard"
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register("dialogInventoryPolicy", {})}
                        className="checkboxStyle"
                      />
                      <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel">{t('inventoryPolicy')}</MDTypography>
                    </Grid>
                  </Grid>
                </Grid>
              </>
              : null
            }
            {/* variant invertory end */}
            {watch('type') == PRODUCT.NORMAL ?
              <>
                {/* variant shipping start */}
                <Grid item xs={12} container spacing={2}>
                  <Grid item xs={12}>
                    <MDTypography variant="h6" className="uppercaseLetters" >{t('shipping')} </MDTypography>
                    <MDTypography component="span" variant="body2" >{t('addShippingDetailsHere')}</MDTypography>
                  </Grid>
                  <Grid item xs={12} lg={12} >
                    <MDInput
                      type="checkbox"
                      name="dialogRequireShipping"
                      variant="standard"
                      disabled
                      InputProps={{
                        classes: { root: "inputBoxStyle" },
                      }}
                      {...register("dialogRequireShipping", {
                      })}
                      className="checkboxStyle"
                    />
                    <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel">{t('requireShipping')}</MDTypography>
                  </Grid>
                  <Grid item xs={12} lg={6} md={6}>
                    <MDTypography variant="body1" className="labelStyle" >{t('weight')}</MDTypography>
                    <Grid item xs={12} lg={12}>
                      <MDInput
                        type="text"
                        name="dialogWeight"
                        placeholder={t('enterWeight')}
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register("dialogWeight", {
                          validate: (value) => {
                            if (value && Number(value) === 0) {
                              return t('invalidInput');
                            }
                            return true;
                          },
                        })}
                        onChange={((e) => {
                          e.stopPropagation();
                          const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                          setValue("dialogWeight", inputValue);
                        })}
                        fullWidth
                      />
                      {errors.dialogWeight && (
                        <span className="errorMsg FloatRight">{errors.dialogWeight.message}</span>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={6} md={6}>
                    <MDTypography variant="body1" className="labelStyle" >{t('weightUnit')}</MDTypography>
                    <Grid item xs={12} lg={12}>
                      <Controller
                        name="dialogWeightUnit"
                        control={control}
                        defaultValue={selectedRow.weightUnit || "kg"}
                        render={({ field }) => (
                          <MDInput
                            select
                            {...field}
                            fullWidth
                            InputProps={{
                              classes: { root: "select-input-styles " },
                            }}
                          >
                            {units.map((unit) => (
                              <MenuItem key={unit.value} value={unit.value}>{unit.name}</MenuItem>
                            ))}
                          </MDInput>
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <MDTypography variant="h6">{t('dimensions')}</MDTypography>
                  </Grid>
                  <Grid item xs={12} lg={6} md={6}>
                    <MDTypography variant="body1" className="labelStyle">{t('width')}
                      <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                    </MDTypography>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        type="text"
                        name="dialogWidth"
                        defaultValue={selectedRow.width || ''}
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register("dialogWidth", {
                          required: {
                            value: true,
                            message: t('widthRequired')
                          },
                          validate: (value) => {
                            if (Number(value) === 0) {
                              return t('invalidInput');
                            }
                            return true;
                          },
                        })}
                        onChange={((e) => {
                          e.stopPropagation();
                          const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                          setValue("dialogWidth", inputValue);
                          setVolumetricWidth(inputValue);
                        })}
                        fullWidth />
                      {errors.dialogWidth && (
                        <span className="errorMsg FloatRight">{errors.dialogWidth.message}</span>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={6} md={6}>
                    <MDTypography variant="body1" className="labelStyle">{t('dHeight')}
                      <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                    </MDTypography>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        type="text"
                        name="dialogHeight"
                        defaultValue={selectedRow.height || ''}
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register("dialogHeight", {
                          required: {
                            value: true,
                            message: t('dHeightRequired')
                          },
                          validate: (value) => {
                            if (Number(value) === 0) {
                              return t('invalidInput');
                            }
                            return true;
                          },
                        })}
                        onChange={((e) => {
                          e.stopPropagation();
                          const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                          setValue("dialogHeight", inputValue);
                          setVolumetricHeight(inputValue);
                        })}
                        fullWidth />
                      {errors.dialogHeight && (<span className="errorMsg FloatRight">{errors.dialogHeight.message}</span>)}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={6} md={6}>
                    <MDTypography variant="body1" className="labelStyle">{t('length')}
                      <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                    </MDTypography>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        type="text"
                        name="dialogLength"
                        defaultValue={selectedRow.length || ''}
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register("dialogLength", {
                          required: {
                            value: true,
                            message: t('lengthRequired')
                          },
                          validate: (value) => {
                            if (Number(value) === 0) {
                              return t('invalidInput');
                            }
                            return true;
                          },
                        })}
                        onChange={((e) => {
                          e.stopPropagation();
                          const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                          setValue("dialogLength", inputValue);
                          setVolumetricLength(inputValue);
                        })}
                        fullWidth />
                      {errors.dialogLength && (<span className="errorMsg FloatRight">{errors.dialogLength.message}</span>)}
                    </Grid>
                  </Grid>
                </Grid>


                {volumetricWeight && (
                                                   <>
                                                    <Grid item xs={12} sm={12} md={12}>

                                                    <MDTypography variant="body1" className="labelStyle">{t('calculatedVolumetricWeight')+' = '}
                                                    {volumetricWeight}
                                                            </MDTypography>
                                                    </Grid>
                                                 
                                                    </>
                                                    )}
                {/* variant shipping end */}
              </>
              :
              <>
                <Grid item xs={12}>
                  <MDTypography variant="h6" className="uppercaseLetters">{t('digitalProductDetails')}</MDTypography>
                  <MDTypography component="span" variant="body2"  >{t('detaileddigitalProduct')}</MDTypography>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <MDTypography variant="body1" className="labelStyle">{t('addDigitalProductAs')}</MDTypography>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                  <Controller
                    name="dialogDigitalType"
                    control={control}
                    rules={{
                    }}
                    defaultValue={"file"}
                    render={({ field }) => (
                      <MDInput
                        select
                        {...field}
                        fullWidth
                        InputProps={{
                          classes: { root: "select-input-styles " },
                        }}
                      >
                        {digitalType.map((type) => (
                          <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                        ))}
                      </MDInput>
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <MDTypography variant="h7">{t('addDigitalProduct')}</MDTypography>
                </Grid>
                {(watch('dialogDigitalType') == 'file') ?
                  <>
                    <Grid item xs={12} sm={4} md={4}>
                      <MDTypography variant="body1" className="labelStyle">{t('uploadFile')}
                        <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <MDInput
                        type="file"
                        name="dialogDigitalFile"
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register('dialogDigitalFile', {
                          required: {
                            value: (dialogDigitalFileInfo && dialogDigitalFileInfo[0]) ? false : true,
                            message: t('digitalFileRequired')
                          }
                        })}
                        onChange={((e) => {
                          e.stopPropagation()
                          const file = e.target.files[0];
                          if (file) {
                            handleDigitalFileUpload(e, "variant", selectedRow.variantId ? selectedRow.variantId : '');
                          }
                        })}
                        fullWidth />
                      {digitalFileUploadLoading ? <CircularProgress color="inherit" size={"20px"} /> : null}
                      {errors.dialogDigitalFile && (<span className="errorMsg FloatRight">{errors.dialogDigitalFile.message}</span>)}
                      {dialogDigitalFileInfo && (
                        <MDTypography component="span" variant="body2" color="inherit">{dialogDigitalFileInfo ? dialogDigitalFileInfo[0] ? dialogDigitalFileInfo[0] : "" : ""}</MDTypography>
                      )}
                    </Grid>
                  </>
                  :
                  <>
                    <Grid item xs={12} sm={4} md={4}>
                      <MDTypography variant="body1" className="labelStyle">{t('digitalProductFileLink')}
                        <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <MDInput
                        type="text"
                        name="dialogDigitalProductFileLink"
                        defaultValue={''}
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                          inputProps: { min: 0 },
                        }}
                        {...register('dialogDigitalProductFileLink', {
                          required: {
                            value: true,
                            message: t('digitalProductFileLinkRequired')
                          },
                          validate: (value) => {
                            if (!isURL(value)) {
                              return t('invalidUrl');
                            }
                            return true;
                          },
                        })}
                        fullWidth />
                      {errors.dialogDigitalProductFileLink && (<span className="errorMsg FloatRight">{errors.dialogDigitalProductFileLink.message}</span>)}
                    </Grid>
                  </>
                }
                <Grid item xs={12} sm={4} md={4}>
                  <MDTypography variant="body1" className="labelStyle">{t('numberOfAccessibleDays')}
                    <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                  </MDTypography>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                  <MDInput
                    type="number"
                    name="dialogNumberOfAccessibleDays"
                    defaultValue={dialogDigitalProductInfo.noOfAccessDays || 0}
                    InputProps={{
                      classes: { root: "inputBoxStyle" },
                      inputProps: { min: 0 },
                    }}
                    {...register('dialogNumberOfAccessibleDays', {
                      required: {
                        value: true,
                        message: t('numberOfAccessibleDaysRequired')
                      }
                    })}
                    fullWidth />
                  {errors.dialogNumberOfAccessibleDays && (<span className="errorMsg FloatRight">{errors.dialogNumberOfAccessibleDays.message}</span>)}
                  <MDTypography component="span" variant="body2" color="error" className="EditProductSpanText">{t('noteForAccessibleDays')}</MDTypography>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <MDTypography variant="body1" className="labelStyle">{t('numberOfDownloads')}
                    <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                  </MDTypography>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                  <MDInput
                    type="number"
                    name="dialogNumberOfDownloads"
                    defaultValue={dialogDigitalProductInfo.noOfDownloads || 0}
                    InputProps={{
                      classes: { root: "inputBoxStyle" },
                      inputProps: { min: 0 },
                    }}
                    {...register('dialogNumberOfDownloads', {
                      required: {
                        value: true,
                        message: t('numberOfDownloadsRequired')
                      }
                    })}
                    fullWidth />
                  {errors.dialogNumberOfDownloads && (<span className="errorMsg FloatRight">{errors.dialogNumberOfDownloads.message}</span>)}
                  <MDTypography component="span" variant="body2" color="error" className="EditProductSpanText">{t('downloadDetails')}</MDTypography>
                </Grid>
              </>
            }
            {/* variant country of origin and hsn start */}
            <Grid item xs={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('chooseCountryOfOrgin')}</MDTypography>
              <MDTypography component="span" variant="body2" >{t('countryOfOriginDetails')}</MDTypography>
            </Grid>
            <Grid item xs={12} lg={12} sm={12} md={12}>
              <Controller
                name="dialogCountryOfOrgin"
                control={control}
                rules={{}}
                defaultValue={selectedDialogCountryOfOrgin || '0'}
                render={({ field }) => (
                  <MDInput
                    select
                    {...field}
                    fullWidth
                    onChange={(event) => {
                      const newValue = event.target.value; // Get the selected value from the event
                      setSelectedDialogCountryOfOrgin(newValue); // Update the selected value
                      field.onChange(newValue); // Update the form state with the new value
                    }}
                    InputProps={{
                      classes: { root: "select-input-styles " },
                    }}
                  >
                    <MenuItem key={0} value='0'>{t('selectCountry')}</MenuItem>
                    {countries.map((unit) => (
                      <MenuItem key={unit.isoCode} value={unit.isoCode}>{unit.name}</MenuItem>
                    ))}
                  </MDInput>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <MDTypography variant="h6" className="uppercaseLetters"  >{t('chooseHsnCode')}</MDTypography>
              
            </Grid>
            <Grid item xs={12} lg={12} sm={12} md={12}>
            <MDInput
                            type="text"
                            name="dialogHsnCode"
                            defaultValue=""
                            placeholder={t('HSN Code')}
                            InputProps={{
                                classes: { root: "inputBoxStyle" },

                            }}
                            {...register("dialogHsnCode", {
                             
                            })}

                            onChange={((e) => {
                              e.stopPropagation();
                              const inputValue = e.target.value;
                              setValue("dialogHsnCode", inputValue);
                            })}


                      
                            fullWidth />
                                       {errors.dialogHsnCode && <span className="errorMsg FloatRight">{errors.hsnCode.message}</span>}

              
              
            </Grid>
            {/* variant country of origin and hsn end*/}
            <Grid item xs={12}>
              <MDButton className="marginRight10" disableRipple onClick={handleEditVariantClose}>{t('Cancel')}</MDButton>
              <MDButton variant="contained" disableRipple color="primary" onClick={e => { handleSaveChanges(e) }}>{t('saveChanges')}</MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Grid>
    </Card>
  )
}
export default EditRow;
